import React from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface CancelButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onCancel: () => void;
}

const CancelButton: React.FC<CancelButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onCancel,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="cancel-button"
      testId="cancel"
      variant="outlined"
      startIcon={<CancelOutlinedIcon />}
      onClick={onCancel}
    />
  );
};
export default CancelButton;
